import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const N: React.FC = () => {
    const { t } = useLang('d3u');
    const imgs: string[] = [
        'https://websiteoss.ecoflow.com/upload/image/1760930330578/14.jpg',
        'https://websiteoss.ecoflow.com/upload/image/1760930437647/14_M.jpg',
    ];

    return (
        <section className={`${css.section} D3U-N GtmModuleData-section`} id="D3U-N" data-section-id={'D3U-N'} data-section-id2={t('N_title')}>
            <div className="info">
                <p className="label">{t('N_label')}</p>
                <p className="title">{t('N_title')}</p>
                <p className="desc">{t('N_desc')}</p>
            </div>
            <div className="img">
                <EcoImg pc={imgs[0]} pad={imgs[0]} h5={imgs[1]} />
            </div>
            <p className="tip">{t('N_tip')}</p>
        </section>
    );
};

export default N;
